import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.883 20.113c-.335.44-.887.76-1.393.536a9 9 0 0 1-2.358-1.525c-.37-.331-.365-.89-.183-1.353a2.9 2.9 0 0 0 .201-1.065c0-1.551-1.209-2.809-2.7-2.809-.152 0-.29-.1-.315-.25A9.8 9.8 0 0 1 3.4 9.253a.05.05 0 0 1 .049-.036c1.491 0 2.7-1.258 2.7-2.81q0-.288-.054-.56c-.082-.42-.019-.885.312-1.158A8.9 8.9 0 0 1 8.8 3.271c.451-.179.936.063 1.268.416.49.523 1.175.847 1.932.847s1.442-.324 1.932-.847c.332-.353.817-.595 1.268-.416.87.344 1.676.825 2.392 1.417.33.273.394.737.312 1.158a3 3 0 0 0-.054.56c0 1.552 1.209 2.81 2.7 2.81a.05.05 0 0 1 .049.036 9.796 9.796 0 0 1 .267 4.396c-.026.15-.164.25-.316.25-1.491 0-2.7 1.257-2.7 2.808 0 .377.071.737.2 1.065.183.463.189 1.021-.182 1.353a9 9 0 0 1-2.357 1.525c-.507.223-1.059-.096-1.394-.536A2.66 2.66 0 0 0 12 19.047c-.858 0-1.623.417-2.117 1.066Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }